import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SketchComponent } from './sketch/sketch.component';
import { DrawComponent } from './draw.component';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SketchService } from './service/sketch.service';
import { DragDropModule } from 'src/app/core/drag-drop/drag-drop.module';
import { CreateComponent } from './create/create.component';
import { EditComponent } from './edit/edit.component';
import { CommonModule } from '@angular/common';

export const DRAW_COMPONENTS = [CreateComponent, EditComponent, SketchComponent, DrawComponent];

@NgModule({
  declarations: DRAW_COMPONENTS,
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    DragDropModule,
    BsDropdownModule.forRoot(),
  ],
  providers: [SketchService],
  exports: DRAW_COMPONENTS,
})
export class DrawModule {}
